<!-- <mat-form-field  class="my-custom-field" fxFlex="100"  [formGroup]="group"  [appearance]="formType">
    <mat-label class="white-text">{{field.label}}</mat-label>
    <mat-select class="white-text" [formControlName]="field.name">
        <mat-option  class="white-text" *ngFor="let item of optionsList" [value]="item">{{item}}</mat-option>
    </mat-select>
</mat-form-field> -->

<mat-form-field class="my-custom-field"  [ngClass]="{'my-custom-field': formType === 'standard', 'new-standard-field': formType === 'newstandard'}"  fxFlex="100"
    [formGroup]="group" [appearance]="formType">
    <mat-label [ngClass]="{'my-custom-field': formType === 'standard', 'new-standard-field': formType === 'newstandard'}" class="white-text">{{field.label}}</mat-label>
    <mat-select [ngClass]="{'my-custom-field': formType === 'standard', 'new-standard-field': formType === 'newstandard'}" [formControlName]="field.name">
        <mat-option *ngFor="let item of optionsList" [value]="item">

            <span>

                {{item}}
            </span>

        </mat-option>
    </mat-select>
    <ng-container *ngFor="let validation of field['dynamicFormLabelValidator'];" ngProjectAs="mat-error">
        <mat-error *ngIf="group.get(field.name).hasError(validation.name)">{{validation.message}}</mat-error>
    </ng-container>
</mat-form-field>